module.exports = __webpack_public_path__ + "img/Holi.68d8f983.jpeg";